"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Cursor.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Cursor = function Cursor(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 130.31 201.34"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Cursor Icon"), _react2.default.createElement("path", {
    className: "cursor",
    d: "M74.5 139.58c-2.09-5.35-4-10.11-5.31-13.51l61.11.16L0 0v177.58l44-41.38c4.7 12.84 16.93 45.52 22.9 55.16 5.1 8.25 10.38 10 13.9 10a11.27 11.27 0 0 0 4.94-1.15c10.76-5.27 6.18-17.79 4.52-21.49-3.34-7.4-10.22-25-15.76-39.14zM6.71 15.88l107 103.65-54.45-.15 1.87 4.63 2.17 5.43c5 12.61 16.8 42.14 20.84 52.12 1.85 4.56 3.11 10.45-1.38 12.64-4.18 2.06-8.17-3.09-10.18-6.34-6.9-11.14-23.87-58.21-24-58.69l-1.76-4.85-40.1 37.73V15.88z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Cursor;